// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1ml0t","filesListContainer":"PosDisputesFiles_filesListContainer__2e_93","filesButton":"PosDisputesFiles_filesButton__3AhtP"};